export function without<T extends object>(obj: T, property: string): T {
  return withoutAny(obj, [property]);
}

export function withoutAny<T extends object>(obj: T, properties: Array<string>): T {
  return Object.fromEntries(Object.entries(obj).filter(([k, v]) => !properties.includes(k))) as T;
}
